import { CrossCategoryMove } from '@app/features/company-management/models/drag-and-drop-move.model'

export const mapCrossMovesByCategory = (
  moves: CrossCategoryMove[]
): { fromCategoryId: number; toCategoryId: number; questionIds: number[] }[] => {
  const map = new Map<string, { fromCategoryId: number; toCategoryId: number; questionIds: number[] }>()
  for (const move of moves) {
    const key = `${move.fromCategoryId}->${move.toCategoryId}`
    const existing = map.get(key)
    if (existing) existing.questionIds.push(move.questionId)
    else
      map.set(key, {
        fromCategoryId: move.fromCategoryId,
        toCategoryId: move.toCategoryId,
        questionIds: [move.questionId],
      })
  }
  return [...map.values()]
}
